class SpinnerService {
    constructor() {
        this.loaderCallback = null;
        this.loaderCount = 0;
    }

    subscribe(callback) {
        this.loaderCallback = callback;
    }

    showSpinner() {
        this.loaderCount++;
        if (this.loaderCallback && this.loaderCount === 1) {
            this.loaderCallback(true);
        }
    }

    hideSpinner() {
        this.loaderCount = Math.max(0, this.loaderCount - 1);
        if (this.loaderCallback && this.loaderCount === 0) {
            this.loaderCallback(false);
        }
    }
}

// Create a singleton instance
const spinnerService = new SpinnerService();

// Export the instance as loaderService to maintain compatibility
export const loaderService = spinnerService;

// Export standalone functions for ease of use
export const showSpinner = () => spinnerService.showSpinner();
export const hideSpinner = () => spinnerService.hideSpinner();
